export default {
  title: 'Mise en page des commandes',
  form: {
    show_hero_image_with_offers: {
      label: "Afficher l'image hero avec les offres",
      description:
        "Par défaut, l'ajout d'une image d'offre masque l'image hero. Activez cette option pour afficher les deux.",
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    failed_to_save_changes: "Échec de l'enregistrement",
    changes_got_saved: 'Modifications enregistrées',
  },
};
